import React, { Component } from "react";
import PropTypes from "prop-types";
import { withAuth } from "../AuthContext";
import { withRouter } from "react-router-dom";

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // email: 'aerrity@gmail.com',
            // password: 'testing',
            email: "",
            password: "",
            rememberMe: false,
            incorrect: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    }

    componentDidMount() {
        this.setState({ incorrect: false });
    }

    handleInputChange(event) {
        const target = event.target;
        const value =
            target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        });
    }

    handleLogin(event) {
        event.preventDefault();
        this.setState({ incorrect: false });
        // TODO CSRF validation currently disabled in Kernel.php

        const headers = {
            "X-CSRF-TOKEN": window.Laravel.csrfToken,
            "X-Requested-With": "XMLHttpRequest",
        };
        const auth = this.props.auth;

        // user['_token'] = window.Laravel.csrfToken;

        axios
            .post("/api/editor/login", this.state, headers)
            .then((response) => {
                auth.handleEditorLogin(response.data.user);
                window.open("/admin/dashboard/posts", "_self");
            })
            .catch((err) => {
                this.setState({ incorrect: true });
            });

        return false;
    }

    render() {
        return (
            <section className="contact-wrapper">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="contact_form">
                                <h3 className="title">Editor Login</h3>

                                <div id="login">
                                    <div id="message" />
                                    <form
                                        method="post"
                                        action="/login"
                                        name="loginform"
                                        id="loginform"
                                        onSubmit={this.handleLogin}
                                    >
                                        <input
                                            type="hidden"
                                            name="csrf-token"
                                            value={window.Laravel.csrfToken}
                                        />

                                        <div className="row">
                                            <div className="col-12  form-group">
                                                <label>Email</label>
                                                <input
                                                    type="email"
                                                    className="form-control person-email"
                                                    placeholder="Your email"
                                                    name="email"
                                                    id="email"
                                                    required
                                                    value={this.state.email}
                                                    onChange={
                                                        this.handleInputChange
                                                    }
                                                />
                                            </div>

                                            <div className="col-12  form-group">
                                                <label>Password</label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    placeholder="Your password"
                                                    required
                                                    minLength="6"
                                                    name="password"
                                                    id="password"
                                                    value={this.state.password}
                                                    onChange={
                                                        this.handleInputChange
                                                    }
                                                />
                                            </div>
                                            {/* <div className="col-12  form-group">
                            <div className="row">
                              <div className="col-12  col-sm-12 col-md-6 form-group">
                                <label>Remember me</label>
                              </div>
                              <div className="col-12  col-sm-12 col-md-2 form-group">
                                <input
                                  type="checkbox"
                                  name="remember"
                                  value={this.state.rememberMe}
                                  onChange={this.handleInputChange}
                                />
                              </div>
                            </div>
                          </div> */}
                                            <div
                                                className="col-12 form-group"
                                                style={{
                                                    visibility: this.state
                                                        .incorrect
                                                        ? "visible"
                                                        : "hidden",
                                                }}
                                            >
                                                <label style={{ color: "red" }}>
                                                    Username or password
                                                    incorrect. Please try again.
                                                </label>
                                            </div>

                                            <div className="submit-btn mt-0">
                                                <input
                                                    className="btn btn-primary"
                                                    value="Submit"
                                                    type="submit"
                                                    name="submit"
                                                    id="submit"
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const makeCancelable = (promise) => {
    let hasCanceled_ = false;

    const wrappedPromise = new Promise((resolve, reject) => {
        promise.then(
            (val) =>
                hasCanceled_ ? reject({ isCanceled: true }) : resolve(val),
            (error) =>
                hasCanceled_ ? reject({ isCanceled: true }) : reject(error)
        );
    });

    return {
        promise: wrappedPromise,
        cancel() {
            hasCanceled_ = true;
        },
    };
};

export default withRouter(withAuth(Login));
